import { render } from "./WhiteBackground.vue?vue&type=template&id=535ac570&scoped=true"
import script from "./WhiteBackground.vue?vue&type=script&lang=js"
export * from "./WhiteBackground.vue?vue&type=script&lang=js"

import "./WhiteBackground.vue?vue&type=style&index=0&id=535ac570&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535ac570"]])

export default __exports__